/* ============================================================================
FILE: po-k1-quiz-texts-fr-en-es-20260321.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK1QuizTextsFR_EN_ES_20260321
ROOT: .po-k1-quiz-section[data-po-k1-quiz="axis_quiz"]

RÔLE:
- injecte le contenu FR/EN/ES du quiz
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- conserve la logique score / réponses / compteur / Flow
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K1_QUIZ_TEXTS_20260321__) return;
  window.__PO_K1_QUIZ_TEXTS_20260321__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k1-quiz-section[data-po-k1-quiz="axis_quiz"]';
  var COUNTER_KEY = "poso_counts";

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));
    return out;
  }

  function getSimplifiedLexiqueFRList() {
    var merged = [];
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        for (var i = 0; i < window.PO_LEXICON_META.lexique_simplifie_fr.length; i++) {
          uniqPush(merged, window.PO_LEXICON_META.lexique_simplifie_fr[i]);
        }
      }
    } catch (e) {}

    [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Axis",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "RéZonans",
      "Péroptissimisme",
      "Aliœvolution",
      "Illusion",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Instantané multiple",
      "Sujet pluriel",
      "Engrenages posœnnoïaux",
      "Posœnnoïaque",
      "Posœnnoïque",
      "Posœnnomia",
      "Posœnnoïamie",
      "Temporalité élargie",
      "Temporalité éclatée"
    ].forEach(function (term) {
      uniqPush(merged, term);
    });

    return merged;
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";
    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.setAttribute("hidden", "");
    }
  }

  function loadCounter() {
    try {
      return JSON.parse(localStorage.getItem(COUNTER_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveCounter(data) {
    try {
      localStorage.setItem(COUNTER_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function bump(path) {
    var data = loadCounter();
    var keys = String(path).split(".");
    var ref = data;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (i === keys.length - 1) {
        ref[k] = (ref[k] || 0) + 1;
      } else {
        ref[k] = ref[k] || {};
        ref = ref[k];
      }
    }
    saveCounter(data);
    try {
      window.dispatchEvent(new StorageEvent("storage", {
        key: COUNTER_KEY,
        newValue: JSON.stringify(data)
      }));
    } catch (e) {}
  }

  function encodeForm(obj) {
    return Object.keys(obj).map(function (k) {
      return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
    }).join("&");
  }

  function sendFlow(payload) {
    try {
      var base = {
        "form_type": "contact",
        "utf8": "✓",
        "contact[subject]": "Quiz_Completed_K1",
        "contact[email]": "noreply@goodyart.store",
        "contact[name]": "Quiz User",
        "contact[body]": JSON.stringify(payload)
      };

      fetch("/contact", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encodeForm(base),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  var UI = {
    fr: {
      langbar_aria: "Langue",
      sections_aria: "Sections du quiz",
      submit_cta: "Afficher le score",
      warning_incomplete: "Merci de répondre à toutes les questions avant d’afficher le score.",
      toggle_answers_show: "👉 Voir les bonnes réponses",
      toggle_answers_hide: "👉 Masquer les bonnes réponses",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoia_2_a0821858-5f59-4ecb-9286-7c7c334fe914.png?v=1770246297",
        alt: "Idéogramme de Posœnnoïa"
      },
      tabs: {
        poso: "Posœnnoïa",
        axis: "Axis",
        engrenages: "Engrenages",
        organon: "Organon",
        symbolique: "Symbolique & nombres"
      },
      sections: {
        poso: {
          title: "Quiz – Posœnnoïa (La Mère)",
          kicker: "Fondement vibratoire et matrice générative."
        },
        axis: {
          title: "Quiz – Katûpirsia 1 : Axis (structure)",
          kicker: "Corps central, articulation et propagation."
        },
        engrenages: {
          title: "Quiz – Engrenages posœnnoïaux",
          kicker: "Accumulation, épure et cohérence mouvante."
        },
        organon: {
          title: "Quiz – Organon & dynamiques",
          kicker: "Orchestration, seuils et respiration du système."
        },
        symbolique: {
          title: "Quiz – Symbolique & nombres",
          kicker: "Nombres-guides, correspondances et calibration."
        }
      },
      scoreText: function (score, total) {
        return "✨ Vous avez obtenu <strong>" + score + "/" + total + "</strong> bonnes réponses.";
      }
    },

    en: {
      langbar_aria: "Language",
      sections_aria: "Quiz sections",
      submit_cta: "Show the score",
      warning_incomplete: "Please answer every question before showing the score.",
      toggle_answers_show: "👉 View the correct answers",
      toggle_answers_hide: "👉 Hide the correct answers",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoia_2_a0821858-5f59-4ecb-9286-7c7c334fe914.png?v=1770246297",
        alt: "Ideogram of Posœnnoïa"
      },
      tabs: {
        poso: "Posœnnoïa",
        axis: "Axis",
        engrenages: "Engrenages",
        organon: "Organon",
        symbolique: "Symbolics & numbers"
      },
      sections: {
        poso: {
          title: "Quiz – Posœnnoïa (The Mother)",
          kicker: "Vibratory foundation and generative matrix."
        },
        axis: {
          title: "Quiz – Katûpirsia 1: Axis (structure)",
          kicker: "Central body, articulation, and propagation."
        },
        engrenages: {
          title: "Quiz – Engrenages posœnnoïaux",
          kicker: "Accumulation, distillation, and moving coherence."
        },
        organon: {
          title: "Quiz – Organon & dynamics",
          kicker: "Orchestration, thresholds, and systemic breathing."
        },
        symbolique: {
          title: "Quiz – Symbolics & numbers",
          kicker: "Guide-numbers, correspondences, and calibration."
        }
      },
      scoreText: function (score, total) {
        return "✨ You scored <strong>" + score + "/" + total + "</strong> correct answers.";
      }
    },

    es: {
      langbar_aria: "Idioma",
      sections_aria: "Secciones del quiz",
      submit_cta: "Mostrar la puntuación",
      warning_incomplete: "Gracias por responder a todas las preguntas antes de mostrar la puntuación.",
      toggle_answers_show: "👉 Ver las respuestas correctas",
      toggle_answers_hide: "👉 Ocultar las respuestas correctas",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoia_2_a0821858-5f59-4ecb-9286-7c7c334fe914.png?v=1770246297",
        alt: "Ideograma de Posœnnoïa"
      },
      tabs: {
        poso: "Posœnnoïa",
        axis: "Axis",
        engrenages: "Engrenages",
        organon: "Organon",
        symbolique: "Simbólica y números"
      },
      sections: {
        poso: {
          title: "Quiz – Posœnnoïa (La Madre)",
          kicker: "Fundamento vibratorio y matriz generativa."
        },
        axis: {
          title: "Quiz – Katûpirsia 1: Axis (estructura)",
          kicker: "Cuerpo central, articulación y propagación."
        },
        engrenages: {
          title: "Quiz – Engrenages posœnnoïaux",
          kicker: "Acumulación, depuración y coherencia en movimiento."
        },
        organon: {
          title: "Quiz – Organon & dinámicas",
          kicker: "Orquestación, umbrales y respiración del sistema."
        },
        symbolique: {
          title: "Quiz – Simbólica y números",
          kicker: "Números-guía, correspondencias y calibración."
        }
      },
      scoreText: function (score, total) {
        return "✨ Ha obtenido <strong>" + score + "/" + total + "</strong> respuestas correctas.";
      }
    }
  };

  var BANK = {
    poso: [
      {
        ans: "b",
        q: {
          fr: "Dans le système, la Posœnnoïa est d’abord :",
          en: "Within the system, Posœnnoïa is first of all:",
          es: "En el sistema, Posœnnoïa es ante todo:"
        },
        options: {
          a: {
            fr: "Un simple mot d’introduction",
            en: "A simple introductory word",
            es: "Una simple palabra introductoria"
          },
          b: {
            fr: "Une matrice vibratoire générative",
            en: "A generative vibratory matrix",
            es: "Una matriz vibratoria generativa"
          },
          c: {
            fr: "Un univers autonome",
            en: "An autonomous universe",
            es: "Un universo autónomo"
          },
          d: {
            fr: "Une pratique rituelle",
            en: "A ritual practice",
            es: "Una práctica ritual"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Rôle de la Posœnnoïa vis-à-vis des 10 Àpákan de l’Axis :",
          en: "Role of Posœnnoïa with respect to the 10 Àpákan of Axis:",
          es: "Papel de Posœnnoïa respecto a los 10 Àpákan de Axis:"
        },
        options: {
          a: {
            fr: "Les isole",
            en: "It isolates them",
            es: "Los aísla"
          },
          b: {
            fr: "Les met en résonance et en circulation",
            en: "It sets them into resonance and circulation",
            es: "Los pone en resonancia y en circulación"
          },
          c: {
            fr: "Les remplace",
            en: "It replaces them",
            es: "Los reemplaza"
          },
          d: {
            fr: "Les fige",
            en: "It freezes them",
            es: "Los inmoviliza"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le « 1 » associé à la Posœnnoïa symbolise :",
          en: "The “1” associated with Posœnnoïa symbolizes:",
          es: "El “1” asociado a Posœnnoïa simboliza:"
        },
        options: {
          a: {
            fr: "Un sommet clos",
            en: "A closed summit",
            es: "Una cima cerrada"
          },
          b: {
            fr: "Une étendue d’activation et de passage",
            en: "A field of activation and passage",
            es: "Una extensión de activación y de paso"
          },
          c: {
            fr: "Une fin de cycle",
            en: "An end of cycle",
            es: "Un final de ciclo"
          },
          d: {
            fr: "Un ornement gématrique",
            en: "A gematric ornament",
            es: "Un adorno gemátrico"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Par rapport aux catégories classiques, la Posœnnoïa :",
          en: "In relation to classical categories, Posœnnoïa:",
          es: "Con respecto a las categorías clásicas, Posœnnoïa:"
        },
        options: {
          a: {
            fr: "S’y soumet strictement",
            en: "Strictly submits to them",
            es: "Se somete estrictamente a ellas"
          },
          b: {
            fr: "Les dépasse par une expérimentation intégrale du vivant",
            en: "Goes beyond them through an integral experimentation of the living",
            es: "Las supera mediante una experimentación integral de lo viviente"
          },
          c: {
            fr: "Supprime la pensée",
            en: "Suppresses thought",
            es: "Suprime el pensamiento"
          },
          d: {
            fr: "Se réduit à l’esthétique",
            en: "Reduces itself to aesthetics",
            es: "Se reduce a la estética"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "La Posœnnoïa relie prioritairement :",
          en: "Posœnnoïa primarily connects:",
          es: "Posœnnoïa conecta prioritariamente:"
        },
        options: {
          a: {
            fr: "Des doctrines concurrentes",
            en: "Competing doctrines",
            es: "Doctrinas concurrentes"
          },
          b: {
            fr: "Ce qui pense, sent, se construit et circule entre les savoirs",
            en: "What thinks, feels, is built, and circulates among forms of knowledge",
            es: "Lo que piensa, siente, se construye y circula entre los saberes"
          },
          c: {
            fr: "Uniquement les symboles",
            en: "Only symbols",
            es: "Únicamente los símbolos"
          },
          d: {
            fr: "Uniquement la matière",
            en: "Only matter",
            es: "Únicamente la materia"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le mantra (« Amour, Paix, Santé, Dignité, Discernement ») éclaire surtout :",
          en: "The mantra (“Love, Peace, Health, Dignity, Discernment”) chiefly illuminates:",
          es: "El mantra (« Amor, Paz, Salud, Dignidad, Discernimiento ») ilumina sobre todo:"
        },
        options: {
          a: {
            fr: "Une dévotion",
            en: "A devotion",
            es: "Una devoción"
          },
          b: {
            fr: "Un axe de discernement opératif",
            en: "An axis of operative discernment",
            es: "Un eje de discernimiento operativo"
          },
          c: {
            fr: "Une morale",
            en: "A morality",
            es: "Una moral"
          },
          d: {
            fr: "Un totem",
            en: "A totem",
            es: "Un tótem"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Dans K1, la Posœnnoïa n’est pas une « base » mais :",
          en: "In K1, Posœnnoïa is not a “base” but rather:",
          es: "En K1, Posœnnoïa no es una « base » sino:"
        },
        options: {
          a: {
            fr: "Un substrat vivant qui induit et redistribue",
            en: "A living substratum that induces and redistributes",
            es: "Un sustrato vivo que induce y redistribuye"
          },
          b: {
            fr: "Une annexe",
            en: "An annex",
            es: "Un anexo"
          },
          c: {
            fr: "Une preuve mathématique",
            en: "A mathematical proof",
            es: "Una prueba matemática"
          },
          d: {
            fr: "Une allégorie isolée",
            en: "An isolated allegory",
            es: "Una alegoría aislada"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "La fonction de cohérence de la Posœnnoïa consiste à :",
          en: "The coherence function of Posœnnoïa consists in:",
          es: "La función de coherencia de Posœnnoïa consiste en:"
        },
        options: {
          a: {
            fr: "Stabiliser sans plasticité",
            en: "Stabilizing without plasticity",
            es: "Estabilizar sin plasticidad"
          },
          b: {
            fr: "Garantir une cohérence fluide et une dynamique d’expansion",
            en: "Guaranteeing fluid coherence and a dynamic of expansion",
            es: "Garantizar una coherencia fluida y una dinámica de expansión"
          },
          c: {
            fr: "Interdire la transmutation",
            en: "Forbidding transmutation",
            es: "Prohibir la transmutación"
          },
          d: {
            fr: "Clore l’Organon posœnnoïal",
            en: "Closing the Organon posœnnoïal",
            es: "Cerrar el Organon posœnnoïal"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Dans K1, l’ensemble des 33 éléments est présenté comme :",
          en: "In K1, the whole set of 33 elements is presented as:",
          es: "En K1, el conjunto de los 33 elementos se presenta como:"
        },
        options: {
          a: {
            fr: "Un inventaire clos",
            en: "A closed inventory",
            es: "Un inventario cerrado"
          },
          b: {
            fr: "Un champ de fréquences opératives",
            en: "A field of operative frequencies",
            es: "Un campo de frecuencias operativas"
          },
          c: {
            fr: "Une chronologie linéaire",
            en: "A linear chronology",
            es: "Una cronología lineal"
          },
          d: {
            fr: "Un système juridique",
            en: "A legal system",
            es: "Un sistema jurídico"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "La Posœnnoïa « ne contient rien », elle :",
          en: "Posœnnoïa “contains nothing”; it:",
          es: "Posœnnoïa « no contiene nada », ella:"
        },
        options: {
          a: {
            fr: "Accumule des dogmes",
            en: "Accumulates dogmas",
            es: "Acumula dogmas"
          },
          b: {
            fr: "Met en résonance",
            en: "Brings into resonance",
            es: "Pone en resonancia"
          },
          c: {
            fr: "Supprime les passages",
            en: "Suppresses passages",
            es: "Suprime los pasos"
          },
          d: {
            fr: "Figurativise les piliers",
            en: "Figurativizes the pillars",
            es: "Figurativiza los pilares"
          }
        }
      }
    ],

    axis: [
      {
        ans: "a",
        q: {
          fr: "L’Axis relie prioritairement :",
          en: "Axis primarily connects:",
          es: "Axis conecta prioritariamente:"
        },
        options: {
          a: {
            fr: "Les 10 Àpákan aux modalités et manifestations",
            en: "The 10 Àpákan to the modalities and manifestations",
            es: "Los 10 Àpákan con las modalidades y manifestaciones"
          },
          b: {
            fr: "Uniquement les pratiques",
            en: "Only the practices",
            es: "Únicamente las prácticas"
          },
          c: {
            fr: "Uniquement les univers",
            en: "Only the universes",
            es: "Únicamente los universos"
          },
          d: {
            fr: "Uniquement la numérologie",
            en: "Only numerology",
            es: "Únicamente la numerología"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Double référence du mot « Axis » :",
          en: "Double reference of the word “Axis”:",
          es: "Doble referencia de la palabra « Axis »:"
        },
        options: {
          a: {
            fr: "Atlas et fractales",
            en: "Atlas and fractals",
            es: "Atlas y fractales"
          },
          b: {
            fr: "Axis mundi et vertèbre axis",
            en: "Axis mundi and the axis vertebra",
            es: "Axis mundi y la vértebra axis"
          },
          c: {
            fr: "Arbre séphirotique et disque solaire",
            en: "The sefirotic tree and the solar disk",
            es: "El árbol sefirótico y el disco solar"
          },
          d: {
            fr: "Fémur et sternum",
            en: "Femur and sternum",
            es: "Fémur y esternón"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Fonction symbolique de la vertèbre axis :",
          en: "Symbolic function of the axis vertebra:",
          es: "Función simbólica de la vértebra axis:"
        },
        options: {
          a: {
            fr: "Inertie du regard",
            en: "Inertia of the gaze",
            es: "Inercia de la mirada"
          },
          b: {
            fr: "Pivot du regard et articulation consciente",
            en: "Pivot of the gaze and conscious articulation",
            es: "Pivote de la mirada y articulación consciente"
          },
          c: {
            fr: "Appui statique",
            en: "Static support",
            es: "Apoyo estático"
          },
          d: {
            fr: "Déni du corps",
            en: "Denial of the body",
            es: "Negación del cuerpo"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "L’Axis est décrit comme :",
          en: "Axis is described as:",
          es: "Axis se describe como:"
        },
        options: {
          a: {
            fr: "Un centre figé",
            en: "A fixed center",
            es: "Un centro fijo"
          },
          b: {
            fr: "Une colonne d’interdépendance structurante",
            en: "A structuring column of interdependence",
            es: "Una columna estructurante de interdependencia"
          },
          c: {
            fr: "Une simple table des matières",
            en: "A simple table of contents",
            es: "Un simple índice"
          },
          d: {
            fr: "Un code juridique",
            en: "A legal code",
            es: "Un código jurídico"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Schéma 1 (« Arbre posœnnoïal ») met en syntonie :",
          en: "Diagram 1 (“Arbre posœnnoïal”) puts into syntony:",
          es: "El Esquema 1 (« Arbre posœnnoïal ») pone en sintonía:"
        },
        options: {
          a: {
            fr: "Uniquement les Modalités opératives",
            en: "Only the Modalités opératives",
            es: "Únicamente las Modalités opératives"
          },
          b: {
            fr: "Les 10 Àpákan de l’Axis",
            en: "The 10 Àpákan of Axis",
            es: "Los 10 Àpákan de Axis"
          },
          c: {
            fr: "Uniquement les Univers",
            en: "Only the Universes",
            es: "Únicamente los Universos"
          },
          d: {
            fr: "Uniquement les Pratiques",
            en: "Only the Practices",
            es: "Únicamente las Prácticas"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "L’Axis « palpite, oscille, module » indique :",
          en: "The fact that Axis “palpitates, oscillates, modulates” indicates:",
          es: "Que Axis « palpita, oscila, modula » indica:"
        },
        options: {
          a: {
            fr: "Immuabilité",
            en: "Immutability",
            es: "Inmutabilidad"
          },
          b: {
            fr: "Plasticité dynamique",
            en: "Dynamic plasticity",
            es: "Plasticidad dinámica"
          },
          c: {
            fr: "Abolition des tensions",
            en: "Abolition of tensions",
            es: "Abolición de las tensiones"
          },
          d: {
            fr: "Réduction au schéma",
            en: "Reduction to the diagram",
            es: "Reducción al esquema"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le rôle de l’Axis dans l’Organon posœnnoïal :",
          en: "The role of Axis within the Organon posœnnoïal:",
          es: "El papel de Axis en el Organon posœnnoïal:"
        },
        options: {
          a: {
            fr: "Limiter la propagation",
            en: "To limit propagation",
            es: "Limitar la propagación"
          },
          b: {
            fr: "Servir d’axe de propagation poïétique",
            en: "To serve as an axis of poietic propagation",
            es: "Servir como eje de propagación poiética"
          },
          c: {
            fr: "Supprimer les outils",
            en: "To suppress the tools",
            es: "Suprimir las herramientas"
          },
          d: {
            fr: "Écarter les engrenages",
            en: "To discard the gears",
            es: "Apartar los engranajes"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "La logique « arbre fonctionnel du vivant posœnnoïal » signifie :",
          en: "The logic of the “functional tree of the posœnnoïal living” means:",
          es: "La lógica del « árbol funcional de lo viviente posœnnoïal » significa:"
        },
        options: {
          a: {
            fr: "Une ontologie décorative",
            en: "A decorative ontology",
            es: "Una ontología decorativa"
          },
          b: {
            fr: "Un corps énergétique en interconnexion",
            en: "An interconnected energetic body",
            es: "Un cuerpo energético en interconexión"
          },
          c: {
            fr: "Un inventaire d’objets",
            en: "An inventory of objects",
            es: "Un inventario de objetos"
          },
          d: {
            fr: "Un modèle euclidien fixe",
            en: "A fixed Euclidean model",
            es: "Un modelo euclidiano fijo"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "L’Axis concerne prioritairement :",
          en: "Axis primarily concerns:",
          es: "Axis concierne prioritariamente a:"
        },
        options: {
          a: {
            fr: "Les 10 Àpákan fondamentaux",
            en: "The 10 fundamental Àpákan",
            es: "Los 10 Àpákan fundamentales"
          },
          b: {
            fr: "Uniquement les 18 Fondamenteurs",
            en: "Only the 18 Fondamenteurs",
            es: "Únicamente los 18 Fondamenteurs"
          },
          c: {
            fr: "Uniquement Posœnnomia",
            en: "Only Posœnnomia",
            es: "Únicamente Posœnnomia"
          },
          d: {
            fr: "Uniquement les pratiques",
            en: "Only the practices",
            es: "Únicamente las prácticas"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Le nom « Axis » est l’axe vivant de :",
          en: "The name “Axis” is the living axis of:",
          es: "El nombre « Axis » es el eje vivo de:"
        },
        options: {
          a: {
            fr: "La transmutation",
            en: "Transmutation",
            es: "La transmutación"
          },
          b: {
            fr: "La soustraction",
            en: "Subtraction",
            es: "La sustracción"
          },
          c: {
            fr: "La clôture",
            en: "Closure",
            es: "El cierre"
          },
          d: {
            fr: "L’inertie",
            en: "Inertia",
            es: "La inercia"
          }
        }
      }
    ],

    engrenages: [
      {
        ans: "b",
        q: {
          fr: "Le couple d’engrenages active :",
          en: "The pair of gears activates:",
          es: "La pareja de engranajes activa:"
        },
        options: {
          a: {
            fr: "Des arrêts de processus",
            en: "Process stoppages",
            es: "Paradas de proceso"
          },
          b: {
            fr: "Accumulation et épure",
            en: "Accumulation and distillation",
            es: "Acumulación y depuración"
          },
          c: {
            fr: "Unicité dogmatique",
            en: "Dogmatic singularity",
            es: "Unicidad dogmática"
          },
          d: {
            fr: "Répétition sans variation",
            en: "Repetition without variation",
            es: "Repetición sin variación"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le Posœnnoïaque (26) oriente plutôt vers :",
          en: "The Posœnnoïaque (26) tends rather toward:",
          es: "El Posœnnoïaque (26) orienta más bien hacia:"
        },
        options: {
          a: {
            fr: "Épure, condensation",
            en: "Distillation, condensation",
            es: "Depuración, condensación"
          },
          b: {
            fr: "Accumulation, amplification, complexification",
            en: "Accumulation, amplification, complexification",
            es: "Acumulación, amplificación, complejización"
          },
          c: {
            fr: "Silence du système",
            en: "Silence of the system",
            es: "Silencio del sistema"
          },
          d: {
            fr: "Réduction à 1",
            en: "Reduction to 1",
            es: "Reducción a 1"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Le Posœnnoïque (28) oriente plutôt vers :",
          en: "The Posœnnoïque (28) tends rather toward:",
          es: "El Posœnnoïque (28) orienta más bien hacia:"
        },
        options: {
          a: {
            fr: "Épure, condensation, structuration",
            en: "Distillation, condensation, structuring",
            es: "Depuración, condensación, estructuración"
          },
          b: {
            fr: "Stratification infinie",
            en: "Infinite stratification",
            es: "Estratificación infinita"
          },
          c: {
            fr: "Désordre",
            en: "Disorder",
            es: "Desorden"
          },
          d: {
            fr: "Accumulation sans fin",
            en: "Endless accumulation",
            es: "Acumulación sin fin"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Effet des engrenages sur les Outils :",
          en: "Effect of the gears on the Outils:",
          es: "Efecto de los engranajes sobre las Outils:"
        },
        options: {
          a: {
            fr: "Neutralisation",
            en: "Neutralization",
            es: "Neutralización"
          },
          b: {
            fr: "Fourniture de matière à densifier / épurer",
            en: "Supply of material to densify / refine",
            es: "Aporte de materia para densificar / depurar"
          },
          c: {
            fr: "Remplacement",
            en: "Replacement",
            es: "Reemplazo"
          },
          d: {
            fr: "Isolement",
            en: "Isolation",
            es: "Aislamiento"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Énoncé correct sur l’équilibre interne :",
          en: "Correct statement about inner balance:",
          es: "Enunciado correcto sobre el equilibrio interno:"
        },
        options: {
          a: {
            fr: "Transformation sans dilution",
            en: "Transformation without dilution",
            es: "Transformación sin dilución"
          },
          b: {
            fr: "Dilution sans transformation",
            en: "Dilution without transformation",
            es: "Dilución sin transformación"
          },
          c: {
            fr: "Stase et clôture",
            en: "Stasis and closure",
            es: "Estasis y cierre"
          },
          d: {
            fr: "Chaos réglé",
            en: "Managed chaos",
            es: "Caos reglado"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Chaîne fonctionnelle (26) donnée :",
          en: "Given functional chain (26):",
          es: "Cadena funcional (26) dada:"
        },
        options: {
          a: {
            fr: "Épure ⇒ Stabilisation",
            en: "Distillation ⇒ Stabilization",
            es: "Depuración ⇒ Estabilización"
          },
          b: {
            fr: "Accumulation ⇒ Amplification ⇒ Complexification ⇒ Stratification ⇒ Ouverture",
            en: "Accumulation ⇒ Amplification ⇒ Complexification ⇒ Stratification ⇒ Opening",
            es: "Acumulación ⇒ Amplificación ⇒ Complejización ⇒ Estratificación ⇒ Apertura"
          },
          c: {
            fr: "Suppression ⇒ Oubli",
            en: "Suppression ⇒ Forgetting",
            es: "Supresión ⇒ Olvido"
          },
          d: {
            fr: "Fixation ⇒ Gel",
            en: "Fixation ⇒ Freeze",
            es: "Fijación ⇒ Congelación"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Chaîne fonctionnelle (28) donnée :",
          en: "Given functional chain (28):",
          es: "Cadena funcional (28) dada:"
        },
        options: {
          a: {
            fr: "Stabilisation ⇒ Épure ⇒ Ouverture",
            en: "Stabilization ⇒ Distillation ⇒ Opening",
            es: "Estabilización ⇒ Depuración ⇒ Apertura"
          },
          b: {
            fr: "Épure ⇒ Condensation ⇒ Structuration ⇒ Quintessence ⇒ Stabilisation",
            en: "Distillation ⇒ Condensation ⇒ Structuring ⇒ Quintessence ⇒ Stabilization",
            es: "Depuración ⇒ Condensación ⇒ Estructuración ⇒ Quintesencia ⇒ Estabilización"
          },
          c: {
            fr: "Complexification ⇒ Ouverture",
            en: "Complexification ⇒ Opening",
            es: "Complejización ⇒ Apertura"
          },
          d: {
            fr: "Gel ⇒ Arrêt",
            en: "Freeze ⇒ Stop",
            es: "Congelación ⇒ Detención"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Intégration au Codex posœnnoïal :",
          en: "Integration into the Codex posœnnoïal:",
          es: "Integración en el Codex posœnnoïal:"
        },
        options: {
          a: {
            fr: "Les engrenages sont des agents moteurs essentiels",
            en: "The gears are essential driving agents",
            es: "Los engranajes son agentes motores esenciales"
          },
          b: {
            fr: "Accessoires optionnels",
            en: "Optional accessories",
            es: "Accesorios opcionales"
          },
          c: {
            fr: "Ornements",
            en: "Ornaments",
            es: "Ornamentos"
          },
          d: {
            fr: "Annexes",
            en: "Annexes",
            es: "Anexos"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Lien avec les Modalités opératives :",
          en: "Link with the Modalités opératives:",
          es: "Vínculo con las Modalités opératives:"
        },
        options: {
          a: {
            fr: "Aucun lien",
            en: "No link",
            es: "Ningún vínculo"
          },
          b: {
            fr: "Leur interplay nourrit l’émergence des Modalités opératives",
            en: "Their interplay feeds the emergence of the Modalités opératives",
            es: "Su interacción alimenta la emergencia de las Modalités opératives"
          },
          c: {
            fr: "Les remplace",
            en: "Replaces them",
            es: "Las reemplaza"
          },
          d: {
            fr: "Les clôt",
            en: "Closes them",
            es: "Las clausura"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "But global :",
          en: "Overall aim:",
          es: "Objetivo global:"
        },
        options: {
          a: {
            fr: "Croissance continue sans effondrement et cohérence mouvante",
            en: "Continuous growth without collapse and moving coherence",
            es: "Crecimiento continuo sin colapso y coherencia móvil"
          },
          b: {
            fr: "Arrêt du système",
            en: "Stopping the system",
            es: "Detención del sistema"
          },
          c: {
            fr: "Uniformisation",
            en: "Uniformization",
            es: "Uniformización"
          },
          d: {
            fr: "Isolation des parties",
            en: "Isolation of the parts",
            es: "Aislamiento de las partes"
          }
        }
      }
    ],

    organon: [
      {
        ans: "a",
        q: {
          fr: "L’Organon posœnnoïal n’est pas une doctrine close mais :",
          en: "The Organon posœnnoïal is not a closed doctrine but:",
          es: "El Organon posœnnoïal no es una doctrina cerrada sino:"
        },
        options: {
          a: {
            fr: "Un organon de transmutation vibratoire",
            en: "An organon of vibratory transmutation",
            es: "Un organon de transmutación vibratoria"
          },
          b: {
            fr: "Une annexe",
            en: "An annex",
            es: "Un anexo"
          },
          c: {
            fr: "Un manifeste juridique",
            en: "A legal manifesto",
            es: "Un manifiesto jurídico"
          },
          d: {
            fr: "Une somme figée",
            en: "A frozen sum",
            es: "Una suma inmóvil"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "L’Organon posœnnoïal opère par :",
          en: "The Organon posœnnoïal operates through:",
          es: "El Organon posœnnoïal opera por:"
        },
        options: {
          a: {
            fr: "Catégories statiques",
            en: "Static categories",
            es: "Categorías estáticas"
          },
          b: {
            fr: "Champs interactifs et orchestration dynamique",
            en: "Interactive fields and dynamic orchestration",
            es: "Campos interactivos y orquestación dinámica"
          },
          c: {
            fr: "Élimination des seuils",
            en: "Elimination of thresholds",
            es: "Eliminación de los umbrales"
          },
          d: {
            fr: "Dogmatisation",
            en: "Dogmatization",
            es: "Dogmatización"
          }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Le nombre-guide de l’Organon posœnnoïal (dans K1) :",
          en: "The guide-number of the Organon posœnnoïal (in K1):",
          es: "El número-guía del Organon posœnnoïal (en K1):"
        },
        options: {
          a: {
            fr: "26",
            en: "26",
            es: "26"
          },
          b: {
            fr: "28",
            en: "28",
            es: "28"
          },
          c: {
            fr: "84",
            en: "84",
            es: "84"
          },
          d: {
            fr: "169",
            en: "169",
            es: "169"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "La lecture gématrique de 84 associe :",
          en: "The gematric reading of 84 associates:",
          es: "La lectura gemátrica de 84 asocia:"
        },
        options: {
          a: {
            fr: "7 × 12 comme convergence cycles / structures",
            en: "7 × 12 as a convergence of cycles / structures",
            es: "7 × 12 como convergencia ciclos / estructuras"
          },
          b: {
            fr: "13 × 6",
            en: "13 × 6",
            es: "13 × 6"
          },
          c: {
            fr: "9 × 9",
            en: "9 × 9",
            es: "9 × 9"
          },
          d: {
            fr: "4 × 21",
            en: "4 × 21",
            es: "4 × 21"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Parmi ces principes, lequel est listé dans K1 :",
          en: "Among these principles, which one is listed in K1:",
          es: "Entre estos principios, ¿cuál figura en K1?"
        },
        options: {
          a: {
            fr: "Porosité régulée",
            en: "Regulated porosity",
            es: "Porosidad regulada"
          },
          b: {
            fr: "Clôture doctrinale",
            en: "Doctrinal closure",
            es: "Cierre doctrinal"
          },
          c: {
            fr: "Inertie",
            en: "Inertia",
            es: "Inercia"
          },
          d: {
            fr: "Uniformité",
            en: "Uniformity",
            es: "Uniformidad"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "« Chaque seuil devient … » :",
          en: "“Each threshold becomes …”:",
          es: "« Cada umbral se vuelve… »:"
        },
        options: {
          a: {
            fr: "Décor",
            en: "Decoration",
            es: "Decorado"
          },
          b: {
            fr: "Tension créatrice",
            en: "Creative tension",
            es: "Tensión creadora"
          },
          c: {
            fr: "Fin de parcours",
            en: "End of a path",
            es: "Fin del recorrido"
          },
          d: {
            fr: "Blocage",
            en: "Blockage",
            es: "Bloqueo"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Cadence de l’Organon posœnnoïal :",
          en: "Cadence of the Organon posœnnoïal:",
          es: "Cadencia del Organon posœnnoïal:"
        },
        options: {
          a: {
            fr: "Centre figé",
            en: "Fixed center",
            es: "Centro fijo"
          },
          b: {
            fr: "Cadence matricielle de transmission / syntonie",
            en: "A matricial cadence of transmission / syntony",
            es: "Cadencia matricial de transmisión / sintonía"
          },
          c: {
            fr: "Silence",
            en: "Silence",
            es: "Silencio"
          },
          d: {
            fr: "Épure sans réseau",
            en: "Distillation without network",
            es: "Depuración sin red"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Rapport Organon posœnnoïal ↔ 10 Àpákan :",
          en: "Relation Organon posœnnoïal ↔ 10 Àpákan:",
          es: "Relación Organon posœnnoïal ↔ 10 Àpákan:"
        },
        options: {
          a: {
            fr: "Isolement",
            en: "Isolation",
            es: "Aislamiento"
          },
          b: {
            fr: "Tissage (piliers, outils, engrenages) et portage des Modalités opératives",
            en: "Weaving (piliers, outils, engrenages) and carrying of the Modalités opératives",
            es: "Tejido (piliers, outils, engrenages) y sostén de las Modalités opératives"
          },
          c: {
            fr: "Remplacement",
            en: "Replacement",
            es: "Reemplazo"
          },
          d: {
            fr: "Réduction",
            en: "Reduction",
            es: "Reducción"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Architecture d’ensemble :",
          en: "Overall architecture:",
          es: "Arquitectura de conjunto:"
        },
        options: {
          a: {
            fr: "Linéaire",
            en: "Linear",
            es: "Lineal"
          },
          b: {
            fr: "Non-linéaire, spiralée",
            en: "Non-linear, spiraled",
            es: "No lineal, espiralada"
          },
          c: {
            fr: "Euclidienne",
            en: "Euclidean",
            es: "Euclidiana"
          },
          d: {
            fr: "Binaire",
            en: "Binary",
            es: "Binaria"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Cohérence du système :",
          en: "Coherence of the system:",
          es: "Coherencia del sistema:"
        },
        options: {
          a: {
            fr: "Bloc immobile",
            en: "Immobile block",
            es: "Bloque inmóvil"
          },
          b: {
            fr: "Respiration ajustée (cohérence ≠ rigidité)",
            en: "Adjusted breathing (coherence ≠ rigidity)",
            es: "Respiración ajustada (coherencia ≠ rigidez)"
          },
          c: {
            fr: "Absence d’ancrage",
            en: "Absence of anchoring",
            es: "Ausencia de anclaje"
          },
          d: {
            fr: "Clôture",
            en: "Closure",
            es: "Cierre"
          }
        }
      }
    ],

    symbolique: [
      {
        ans: "b",
        q: {
          fr: "Le « 1 » posœnnoïal, dans K1, est :",
          en: "The posœnnoïal “1”, in K1, is:",
          es: "El « 1 » posœnnoïal, en K1, es:"
        },
        options: {
          a: {
            fr: "Sommet figé",
            en: "A fixed summit",
            es: "Una cima fija"
          },
          b: {
            fr: "Moteur d’unité hétérogène et de passage",
            en: "A motor of heterogeneous unity and passage",
            es: "Motor de unidad heterogénea y de paso"
          },
          c: {
            fr: "Reste décoratif",
            en: "A decorative remainder",
            es: "Un resto decorativo"
          },
          d: {
            fr: "Silence numérique",
            en: "Numerical silence",
            es: "Silencio numérico"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Organon posœnnoïal : nombre-guide indiqué :",
          en: "Organon posœnnoïal: indicated guide-number:",
          es: "Organon posœnnoïal: número-guía indicado:"
        },
        options: {
          a: {
            fr: "84",
            en: "84",
            es: "84"
          },
          b: {
            fr: "26",
            en: "26",
            es: "26"
          },
          c: {
            fr: "28",
            en: "28",
            es: "28"
          },
          d: {
            fr: "169",
            en: "169",
            es: "169"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Engrenage Posœnnoïaque :",
          en: "Posœnnoïaque gear:",
          es: "Engranaje Posœnnoïaque:"
        },
        options: {
          a: {
            fr: "28",
            en: "28",
            es: "28"
          },
          b: {
            fr: "26",
            en: "26",
            es: "26"
          },
          c: {
            fr: "13",
            en: "13",
            es: "13"
          },
          d: {
            fr: "171",
            en: "171",
            es: "171"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Engrenage Posœnnoïque :",
          en: "Posœnnoïque gear:",
          es: "Engranaje Posœnnoïque:"
        },
        options: {
          a: {
            fr: "26",
            en: "26",
            es: "26"
          },
          b: {
            fr: "28",
            en: "28",
            es: "28"
          },
          c: {
            fr: "84",
            en: "84",
            es: "84"
          },
          d: {
            fr: "22",
            en: "22",
            es: "22"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Fonction des nombres-guides :",
          en: "Function of the guide-numbers:",
          es: "Función de los números-guía:"
        },
        options: {
          a: {
            fr: "Ornements",
            en: "Ornaments",
            es: "Ornamentos"
          },
          b: {
            fr: "Repères dynamiques de calibration et d’ajustement",
            en: "Dynamic markers of calibration and adjustment",
            es: "Referentes dinámicos de calibración y ajuste"
          },
          c: {
            fr: "Clôtures symboliques",
            en: "Symbolic closures",
            es: "Clausuras simbólicas"
          },
          d: {
            fr: "Index juridiques",
            en: "Legal indexes",
            es: "Índices jurídicos"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "L’Axis est aussi un :",
          en: "Axis is also a:",
          es: "Axis es también un:"
        },
        options: {
          a: {
            fr: "Simple titre",
            en: "Simple title",
            es: "Simple título"
          },
          b: {
            fr: "Axe vivant de transmutation (axis mundi / axis anatomique)",
            en: "Living axis of transmutation (axis mundi / anatomical axis)",
            es: "Eje vivo de transmutación (axis mundi / axis anatómico)"
          },
          c: {
            fr: "Appendice",
            en: "Appendix",
            es: "Apéndice"
          },
          d: {
            fr: "Épure sans corps",
            en: "Distillation without body",
            es: "Depuración sin cuerpo"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "K1 qualifie l’ensemble (33 éléments) comme :",
          en: "K1 qualifies the whole set (33 elements) as:",
          es: "K1 califica el conjunto (33 elementos) como:"
        },
        options: {
          a: {
            fr: "Liste close",
            en: "Closed list",
            es: "Lista cerrada"
          },
          b: {
            fr: "Méta-structure opérative ouverte",
            en: "An open operative meta-structure",
            es: "Metaestructura operativa abierta"
          },
          c: {
            fr: "Système de preuves",
            en: "System of proofs",
            es: "Sistema de pruebas"
          },
          d: {
            fr: "Théorème",
            en: "Theorem",
            es: "Teorema"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "La dynamique voulue par les nombres 26 / 28 est :",
          en: "The dynamic intended by the numbers 26 / 28 is:",
          es: "La dinámica querida por los números 26 / 28 es:"
        },
        options: {
          a: {
            fr: "Accumulation / Épure en oscillation régulée",
            en: "Accumulation / Distillation in regulated oscillation",
            es: "Acumulación / Depuración en oscilación regulada"
          },
          b: {
            fr: "Silence",
            en: "Silence",
            es: "Silencio"
          },
          c: {
            fr: "Fixation",
            en: "Fixation",
            es: "Fijación"
          },
          d: {
            fr: "Uniformité",
            en: "Uniformity",
            es: "Uniformidad"
          }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Le rapport 7 × 12 pour 84 signifie :",
          en: "The ratio 7 × 12 for 84 signifies:",
          es: "La relación 7 × 12 para 84 significa:"
        },
        options: {
          a: {
            fr: "Cycle intérieur × structures cosmiques",
            en: "Inner cycle × cosmic structures",
            es: "Ciclo interior × estructuras cósmicas"
          },
          b: {
            fr: "Décor",
            en: "Decoration",
            es: "Decorado"
          },
          c: {
            fr: "Arbitraire",
            en: "Arbitrariness",
            es: "Arbitrariedad"
          },
          d: {
            fr: "Hasard",
            en: "Chance",
            es: "Azar"
          }
        }
      },
      {
        ans: "b",
        q: {
          fr: "« Cohérence = respiration » implique :",
          en: "“Coherence = breathing” implies:",
          es: "« Coherencia = respiración » implica:"
        },
        options: {
          a: {
            fr: "Rigidité",
            en: "Rigidity",
            es: "Rigidez"
          },
          b: {
            fr: "Synchroniser sans uniformiser",
            en: "Synchronizing without uniformizing",
            es: "Sincronizar sin uniformizar"
          },
          c: {
            fr: "Uniformiser sans synchroniser",
            en: "Uniformizing without synchronizing",
            es: "Uniformizar sin sincronizar"
          },
          d: {
            fr: "Clore les seuils",
            en: "Closing thresholds",
            es: "Cerrar los umbrales"
          }
        }
      }
    ]
  };

  function getUI(lang) {
    return UI[lang] || UI.fr;
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applySectionTabs(root, lang, sectionKey) {
    var ui = getUI(lang);
    var nav = root.querySelector("[data-po-section-tabs]");
    if (nav) {
      nav.setAttribute("aria-label", ui.sections_aria);
    }

    var labels = root.querySelectorAll("[data-po-section-label]");
    for (var i = 0; i < labels.length; i++) {
      var key = labels[i].getAttribute("data-po-section-label");
      setText(labels[i], ui.tabs[key] || key);
    }

    var buttons = root.querySelectorAll("[data-k1-section]");
    for (var j = 0; j < buttons.length; j++) {
      var isActive = buttons[j].getAttribute("data-k1-section") === sectionKey;
      if (isActive) buttons[j].classList.add("active");
      else buttons[j].classList.remove("active");
    }
  }

  function clearWarn(root) {
    var list = root.querySelector("#questionsList-k1");
    if (list) {
      var warns = list.querySelectorAll(".warn");
      for (var i = 0; i < warns.length; i++) warns[i].classList.remove("warn");
    }
    var warn = root.querySelector("#k1-warning");
    if (warn) warn.classList.add("hidden");
  }

  function clearFeedback(root) {
    var result = root.querySelector("#resultat-k1");
    var answersBox = root.querySelector("#reponsesBox-k1");
    var answersList = root.querySelector("#reponsesList-k1");
    if (result) result.innerHTML = "";
    if (answersBox) answersBox.classList.add("hidden");
    if (answersList) {
      answersList.classList.add("hidden");
      answersList.innerHTML = "";
    }
    root.dataset.submitted = "0";
    clearWarn(root);
  }

  function collectSelections(root, sectionKey) {
    var out = {};
    var bank = BANK[sectionKey] || [];
    for (var i = 0; i < bank.length; i++) {
      var qid = "k1q" + (i + 1);
      var checked = root.querySelector('input[name="' + qid + '"]:checked');
      if (checked) out[qid] = checked.value;
    }
    return out;
  }

  function firstUnanswered(root, total) {
    for (var i = 1; i <= total; i++) {
      var name = "k1q" + i;
      if (!root.querySelector('input[name="' + name + '"]:checked')) return i;
    }
    return 0;
  }

  function applyFrame(root, lang, sectionKey) {
    var ui = getUI(lang);
    var sec = ui.sections[sectionKey] || ui.sections.poso;

    setImg(root.querySelector('[data-po-slot="title_img"]'), ui.title_img);
    setText(root.querySelector('[data-po-slot="title"]'), sec.title);
    setText(root.querySelector('[data-po-slot="kicker"]'), sec.kicker);
    setText(root.querySelector('[data-po-slot="submit_cta"]'), ui.submit_cta);
    setText(root.querySelector('[data-po-slot="warning_incomplete"]'), ui.warning_incomplete);
    setText(root.querySelector('[data-po-slot="toggle_answers_show"]'), ui.toggle_answers_show);
    setText(root.querySelector('[data-po-slot="cta_translate"]'), ui.cta_translate);

    var langbar = root.querySelector("[data-po-langbar]");
    if (langbar) langbar.setAttribute("aria-label", ui.langbar_aria);

    applyLangbar(root, lang);
    applySectionTabs(root, lang, sectionKey);
  }

  function renderQuestions(root, sectionKey, lang, preservedSelections) {
    var list = root.querySelector("#questionsList-k1");
    if (!list) return;

    var bank = BANK[sectionKey] || [];
    list.innerHTML = "";

    for (var i = 0; i < bank.length; i++) {
      var item = bank[i];
      var qid = "k1q" + (i + 1);
      var qText = (item.q[lang] || item.q.fr);
      var li = document.createElement("li");

      var html = '<p>' + protectLexiconInHTML(qText) + '</p>';
      ["a", "b", "c", "d"].forEach(function (key) {
        var opt = item.options[key][lang] || item.options[key].fr;
        html += '<label><input type="radio" name="' + qid + '" value="' + key + '"> ' +
          protectLexiconInHTML(opt) + '</label>';
      });

      li.innerHTML = html;
      list.appendChild(li);

      if (preservedSelections && preservedSelections[qid]) {
        var radio = li.querySelector('input[value="' + preservedSelections[qid] + '"]');
        if (radio) radio.checked = true;
      }
    }
  }

  function renderSection(root, sectionKey, lang, preservedSelections) {
    var safeLang = normLang(lang) || "fr";
    var safeSection = BANK[sectionKey] ? sectionKey : "poso";

    root.dataset.currentSection = safeSection;
    applyFrame(root, safeLang, safeSection);
    renderQuestions(root, safeSection, safeLang, preservedSelections || null);
    clearFeedback(root);
  }

  function validateSection(root) {
    var lang = getLang();
    var ui = getUI(lang);
    var sectionKey = root.dataset.currentSection || "poso";
    var bank = BANK[sectionKey] || [];
    var total = bank.length;
    var missingIndex = firstUnanswered(root, total);

    clearWarn(root);

    if (missingIndex) {
      var list = root.querySelector("#questionsList-k1");
      var li = list && list.children[missingIndex - 1];
      var warn = root.querySelector("#k1-warning");
      if (li) {
        li.classList.add("warn");
        try {
          li.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (e) {}
      }
      if (warn) warn.classList.remove("hidden");
      return;
    }

    var score = 0;
    var bonnes = [];

    for (var i = 0; i < bank.length; i++) {
      var item = bank[i];
      var qid = "k1q" + (i + 1);
      var checked = root.querySelector('input[name="' + qid + '"]:checked');
      if (checked && checked.value === item.ans) score++;

      var good = item.options[item.ans][lang] || item.options[item.ans].fr;
      bonnes.push("<li>" + protectLexiconInHTML(good) + "</li>");
    }

    var result = root.querySelector("#resultat-k1");
    var answersBox = root.querySelector("#reponsesBox-k1");
    var answersList = root.querySelector("#reponsesList-k1");
    var toggle = root.querySelector("#toggleAnswersK1");

    if (result) result.innerHTML = ui.scoreText(score, total);
    if (answersBox) answersBox.classList.remove("hidden");
    if (answersList) {
      answersList.innerHTML = "<ol>" + bonnes.join("") + "</ol>";
      answersList.classList.add("hidden");
    }
    if (toggle) toggle.textContent = ui.toggle_answers_show;

    if (root.dataset.submitted !== "1") {
      bump("k1." + sectionKey);

      sendFlow({
        quiz: "K1",
        section: sectionKey,
        section_title: (ui.sections[sectionKey] && ui.sections[sectionKey].title) || "",
        score: score,
        total: total,
        lang: lang,
        ts: new Date().toISOString(),
        ua: navigator.userAgent,
        ref: document.referrer || "",
        href: location.href
      });

      root.dataset.submitted = "1";
    }
  }

  function toggleAnswers(root) {
    var lang = getLang();
    var ui = getUI(lang);
    var answersBox = root.querySelector("#reponsesBox-k1");
    var answersList = root.querySelector("#reponsesList-k1");
    var toggle = root.querySelector("#toggleAnswersK1");

    if (!answersBox || !answersList || !toggle) return;
    if (answersBox.classList.contains("hidden")) return;

    answersList.classList.toggle("hidden");
    toggle.textContent = answersList.classList.contains("hidden")
      ? ui.toggle_answers_show
      : ui.toggle_answers_hide;
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function bindActions(root) {
    if (!root || root.__poK1QuizBound) return;
    root.__poK1QuizBound = true;

    var langButtons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < langButtons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(langButtons[i]);
    }

    var sectionButtons = root.querySelectorAll("[data-k1-section]");
    for (var j = 0; j < sectionButtons.length; j++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          renderSection(root, btn.getAttribute("data-k1-section"), getLang(), null);
        });
      })(sectionButtons[j]);
    }

    var submit = root.querySelector("#k1-submit");
    if (submit) {
      submit.addEventListener("click", function () {
        validateSection(root);
      });
    }

    var toggle = root.querySelector("#toggleAnswersK1");
    if (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        toggleAnswers(root);
      });
    }

    var list = root.querySelector("#questionsList-k1");
    if (list) {
      list.addEventListener("change", function () {
        clearWarn(root);
      });
    }
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionKey = root.dataset.currentSection || "poso";
      var preservedSelections = collectSelections(root, sectionKey);
      renderSection(root, sectionKey, safeLang, preservedSelections);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function initOne(root) {
    if (!root || root.__poK1QuizInit) return;
    root.__poK1QuizInit = true;

    lockTranslation(root);
    bindActions(root);

    var defaultSection = root.getAttribute("data-po-default-section") || "poso";
    renderSection(root, defaultSection, getLang(), null);
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  window.PoK1QuizTextsFR_EN_ES_20260321 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    renderSection: renderSection,
    protectLexiconInHTML: protectLexiconInHTML
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.PosoMini = window.PosoMini || {};
  window.PosoMini.bump = bump;
  window.PosoMini.loadKey = function () { return COUNTER_KEY; };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();